<template>
  <div style="min-height: 100vh">
    <el-row style="margin: 25px 0;">
      <el-col :sm="3" style="padding-top: 10px">
        <el-button size="mini" icon="el-icon-arrow-left" @click="m__back_to_list">{{ $t('base.back') }}</el-button>
      </el-col>
      <el-col :sm="21">
      </el-col>
    </el-row>

    <div>
      <p><strong style="font-size: 18px">{{ flash_sale && flash_sale.session_name }}</strong></p>
      <div v-if="flash_sale" style="display: flex; gap: 60px;">
        <div>
          <div style="font-size: 14px">Thời gian đăng ký</div>
          <div style="font-size: 14px; margin-top: 10px">
            {{ flash_sale.seller_nomination_start_time * 1000 | moment('HH:mm DD/MM/YYYY') }}
            -
            {{ flash_sale.seller_nomination_end_time * 1000 | moment('HH:mm DD/MM/YYYY') }}
          </div>
        </div>
        <div>
          <div style="font-size: 14px">Thời gian diễn ra chương trình</div>
          <div style="font-size: 14px; margin-top: 10px">
            {{ flash_sale.session_start_time * 1000 | moment('HH:mm DD/MM/YYYY') }}
            -
            {{ flash_sale.session_end_time * 1000 | moment('HH:mm DD/MM/YYYY') }}
          </div>
        </div>
      </div>
    </div>

    <br>
    <br>

    <el-row style="margin-bottom: 20px">
      <el-col :sm="12">
        <div>
          <p><strong style="font-size: 18px">Đăng ký cho khung giờ</strong></p>
          <!--          <pre>{{ session_nomination_statistics }}</pre>-->
          <div v-if="campaign" style="display: flex; gap: 60px;">
            <div>
              <div style="font-size: 14px;">
                {{ campaign.description }}
              </div>
              <div style="font-size: 14px; margin-top: 10px">
                <!--                Số lượng đăng ký: {{ campaign.allow_seller_nomination }}-->
                Số lượng đăng ký: {{ campaign.nomination_seat }}
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :sm="12" class="text-right">
        <el-button size="mini" icon="el-icon-info" type="info"
                   @click="m__show_flash_sale_files_dialog">
          {{ $t('flash_sale.saved_file') }}
        </el-button>
        <el-button size="mini" type="primary" icon="el-icon-plus"
                   @click="m__show_select_product_dialog">
          {{ $t('base.add_products') }}
        </el-button>
      </el-col>
    </el-row>

    <div v-loading="loading_get_products" style="margin: 40px 0">
      <el-tabs v-model="tab">
        <el-tab-pane :label="`Chờ đăng ký (${session_nomination_statistics.pending_submission_count || 0})`"
                     name="preview">
          <Component_FlashSaleProduct
            :id="'create-sticky-' + tab"
            :seller="seller"
            :product_selected_list.sync="preview_product_selected_list"
            :shop_id="shop_id"
            :shopee_id="shopee_id"
            :get_data="loading.get_data"
            :is_preview="true"
            :campaigns="campaigns"
            @m__remove_product="m__remove_product"
            @m__get_flash_sale_files="m__get_flash_sale_files">
          </Component_FlashSaleProduct>
        </el-tab-pane>
        <el-tab-pane :label="`Đã đăng ký (${session_nomination_statistics.nominated_count || 0})`" name="0">
          <Component_FlashSaleProduct
            :id="'create-sticky'"
            :seller="seller"
            :product_selected_list.sync="product_selected_list"
            :shop_id="shop_id"
            :shopee_id="shopee_id"
            :get_data="loading.get_data"
            :campaigns="campaigns"
            @m__remove_product="m__remove_product"
            @m__get_flash_sale_files="m__get_flash_sale_files">
          </Component_FlashSaleProduct>
        </el-tab-pane>
        <el-tab-pane :label="`Chờ xác nhận (${session_nomination_statistics.pending_seller_count || 0})`" name="1">
          <Component_FlashSaleProduct
            :id="'create-sticky'"
            :seller="seller"
            :product_selected_list.sync="product_selected_list"
            :shop_id="shop_id"
            :shopee_id="shopee_id"
            :get_data="loading.get_data"
            :campaigns="campaigns"
            @m__remove_product="m__remove_product"
            @m__get_flash_sale_files="m__get_flash_sale_files">
          </Component_FlashSaleProduct>
        </el-tab-pane>
        <el-tab-pane :label="`Đã bị từ chối (${session_nomination_statistics.rejected_count || 0})`" name="3">
          <Component_FlashSaleProduct
            :id="'create-sticky'"
            :seller="seller"
            :product_selected_list.sync="product_selected_list"
            :shop_id="shop_id"
            :shopee_id="shopee_id"
            :get_data="loading.get_data"
            :campaigns="campaigns"
            @m__remove_product="m__remove_product"
            @m__get_flash_sale_files="m__get_flash_sale_files">
          </Component_FlashSaleProduct>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div
      style="position: fixed; background-color: #fff; width: calc(100vw - 254px); height: 40px; margin-left: -15px; bottom: 0; z-index: 10">
      <div style="display: flex; justify-content: right; align-items: center; padding-right: 5px; height: 100%">
        <template v-if="tab === 'preview'">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__submit_online_nominated_entity"
                     :loading="loading.submit_online">Gửi yêu cầu đăng ký
          </el-button>
        </template>
        <template v-if="tab === '0'">
          <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.edit_online"
                     @click="m__edit_entity_online">
            {{ $t('base.update') }}
          </el-button>
        </template>
      </div>
    </div>

    <el-dialog width="1300px" :close-on-click-modal="false" :visible.sync="show_dialog.select_product"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row type="margin-top: 10px">
          <el-col :sm="12">
            <p v-if="loading.get_product"><span class="el-icon-loading"></span>
              <strong style="font-size: 18px" class="text-danger">
                {{ $t('base.loading_products') }}
              </strong>
            </p>
            <p v-else>
              <strong style="font-size: 18px">{{ $t('select.products') }}
                <a href="javascript:void(0)" style="font-size: 14px" @click="m__get_product()">
                  ({{ $t('base.update_data') }})
                </a>
              </strong>
            </p>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input type="text" size="mini" v-model="product_filter.keyword" style="width: 300px"
                      :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change">
          <el-table-column width="40px" fixed="left">
            <template slot="header" slot-scope="scope">
              <el-checkbox size="mini" :indeterminate="indeterminate" v-model="is_selected_all"
                           @change="m__select_all" :disabled="!m__can_add_product()"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.selected" @change="m__indeterminate"
                           :disabled="!m__can_add_product()"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                   style="width:35px; height: 35px;"> &nbsp;&nbsp;&nbsp; {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.add_to_cart_units_30_days')" prop="add_to_cart_units" width="160px"
                           sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('base.monthly_sales')" prop="monthly_sales" width="150px" sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="150px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.price | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.revenue | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="150px" sortable="custom">
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="prev, pager, next, total" :total="c__product_filter_list.length"/>

        <el-row style="margin-top: 10px">
          <el-col :sm="12">
            &nbsp;
          </el-col>
          <el-col :sm="12" class="text-right">
            <small>{{ $t('base.selected') }} <span
              style="color: orangered">{{ product_list.filter(i => i.selected).length }}</span> /
              <span
                style="color: orangered">{{ product_list.length }}</span> {{ $t('base.products') }}</small>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_select_product"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_dialog.flash_sale_files"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-col :sm="12">
          <strong style="font-size: 14px">Các tệp đã lưu</strong> &nbsp;&nbsp;
        </el-col>
        <el-col :sm="12" class="text-right">
          <el-input size="mini" :placeholder="$t('flash_sale.search_placeholder')" style="max-width: 250px;"
                    prefix-icon="el-icon-search" v-model="input_keyword" clearable/>
        </el-col>
        <br>
        <br>
        <el-table :data="c__flash_sale_files_filter_list">
          <el-table-column :label="$t('base.filename')" prop="filename">
            <template slot-scope="scope">
              {{ scope.row.filename }} <br>
              <span style="font-size: 11px; font-weight: 600">ID: {{ scope.row.id }}</span> <br>
              <span v-if="scope.row.auto" class="text-running">
                <a href="javascript:void(0)">{{ $t('flash_sale.auto_config_message_2') }}</a>
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.created_at')" prop="createdAt">
            <template slot-scope="scope">{{ scope.row.createdAt | moment('DD-MM-YYYY HH:mm') }}</template>
          </el-table-column>
          <el-table-column :label="$t('flash_sale.no_of_product')" width="120px">
            <template slot-scope="scope">{{ scope.row.products.length }}</template>
          </el-table-column>
          <el-table-column :label="$t('base.shop')">
            <template slot-scope="scope">
              <template v-if="scope.row.shopId">
                <a href="javascript:void(0)" @click="m__show_select_shop_dialog(scope.row)">
                  <strong class="text-warning">{{ m__get_shop_name(scope.row) }}</strong>
                </a>
              </template>
              <template v-else>
                <el-button type="text" size="mini" @click="m__show_select_shop_dialog(scope.row)">
                  <strong class="text-primary">{{ $t('select.shop') }}</strong></el-button>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.optional')" width="120px">
            <template slot-scope="scope">
              <el-button size="mini" type="text" :loading="loading.use_file" @click="m__use_flash_sale_file(scope.row)">
                <strong class="text-success">{{ $t('base.use_file') }}</strong></el-button>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="m__show_flash_sale_file_products(scope.row)">
                <strong class="text-warning">{{ $t('base.update_file') }}</strong></el-button>
              <el-button size="mini" type="text" @click="m__delete_flash_sale_file(scope.row)">
                <strong class="text-danger">Xóa file</strong></el-button>
              <div style="height: 5px"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog width="1300px" :close-on-click-modal="false" :visible.sync="show_dialog.show_flash_sale_file_products"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <div style="display: flex; align-items: center; margin-bottom: 20px">
          <div style="flex: 0 1 auto">
            <div>
              <strong class="strong-label">{{ $t('base.filename') }}</strong>
              <el-input size="mini" v-model="selected_file_update.filename" style="width: 400px"></el-input>
              &nbsp;&nbsp;
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="m__update_flash_sale_filename">
                {{ $t('base.edit_filename') }}
              </el-button>
              <!--              <el-button size="mini" type="primary" icon="el-icon-plus"
                                       @click="m__show_add_product_to_flash_sale_file_dialog">
                              {{ $t('base.add_products') }}
                            </el-button>-->
              <!--              <el-button size="mini" type="primary" icon="el-icon-upload"-->
              <!--                         @click="m__show_import_product_dialog('flash_sale_file')">-->
              <!--                {{ $t('base.import_products') }}-->
              <!--              </el-button>-->
            </div>
          </div>
          <div style="flex: 1; text-align: right">
            <strong class="strong-label">&nbsp;</strong>
            <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_discount_flash_sale_file"
                       :loading="loading.update_discount">{{ $t('flash_sale.update_file') }}
            </el-button>
          </div>
        </div>

        <div>
          <strong class="text-danger">
            * {{ $t('flash_sale.setup_products_note') }}
          </strong>
        </div>

        <Component_FlashSaleProduct
          :id="'file-sticky'"
          style="margin-top: 10px"
          :seller="seller"
          :product_selected_list.sync="flash_sale_file_product_list"
          :flash_sale_created="[]"
          :shop_id="shop_id"
          :save_current_product="false"
          :show_enable="false"
          :campaigns="campaigns"
          @m__remove_product="m__remove_flash_sale_file_product">
        </Component_FlashSaleProduct>

        <div style="margin-top: 20px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_discount_flash_sale_file"
                     :loading="loading.update_discount">{{ $t('flash_sale.update_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Component_FlashSaleProduct from './product'
import {drop as _drop, orderBy as _orderBy, take as _take} from 'lodash'

export default {
  name: '',

  components: {
    Component_FlashSaleProduct
  },

  props: {
    shops: null,
    shop: null,
    shop_id: null,
    shopee_id: null,
    seller: null,

    flash_sale: null,
    cluster: null,

    campaigns: {
      type: Array,
      default: []
    },

    copy_from_id: null,
    loading_get_products: {
      type: Boolean,
      default: false
    },
    product_list: {
      type: Array,
      default: []
    },
    item_stock_price_infos: {
      type: Array,
      default: []
    },
    model_list: {
      type: Object,
      default: {}
    },
    selected_product_ids: {
      type: Array,
      default: []
    },
    flash_sale_files: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      campaign: {},

      save_and_apply_successfully: false,
      loading: {
        get_product: false,
        save_and_apply: false,
        create_flash_sale_file: false,
        select_shop: false,
        update_auto: false,
        update_discount: false,
        get_data: false,
        submit_online: false,
        edit_online: false,
        use_file: false
      },
      show_dialog: {
        select_product: false,
        time_slot: false,
        create_flash_sale_file: false,
        create_flash_sale_filename: false,
        flash_sale_files: false,
        flash_sale_file_detail: false,
        show_flash_sale_file_products: false,
        select_shop: false,
        update_auto: false
      },
      indeterminate: false,
      is_selected_all: false,
      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        available: false
      },
      product_sort_option: {
        order: null,
        prop: null
      },
      input_keyword: '',

      product_selected_list: [],
      preview_product_selected_list: [],
      // filename: '',
      // flash_sale_files: [],
      // flash_sale_file_products: []

      flash_sale_file_product_list: [],

      selected_file_update: {},

      tab: '0',

      preview_no: '',

      session_nomination_statistics: {}
    }
  },

  async beforeMount() {
    while (this.loading_get_products) {
      await this.sleep(500)
    }

    console.log('campaigns', this.campaigns)
    console.log('cluster', this.cluster)
    this.campaign = this.campaigns[0]

    this.product_list.forEach(i => i.selected = false)

    await this.m__get_session_nomination_statistics()
    if (+this.session_nomination_statistics.pending_submission_count) {
      this.tab = 'preview'
    }

    try {
      await this.m__get_product_list()
    } catch (e) {
      console.error(e)
    }
  },

  watch: {
    'tab': async function () {
      await this.m__get_session_nomination_statistics()
      await this.m__get_preview_product_list()
      await this.m__get_product_list()
    }
  },

  computed: {
    c__product_filter_list() {
      let result = this.product_list

      if (this.product_filter.available) {
        result = result.filter(i => !i.created)
      }

      if (!this.show_dialog.create_flash_sale_file) {
        result = result.filter(i => !this.product_selected_list.find(ii => ii.product.itemid === i.itemid))
      }

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.product_filter.keyword)
      return result.filter(item => this.remove_unicode(JSON.stringify({
        id: item.itemid,
        name: item.name
      })).includes(words))
    },

    c__product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)
      return _take(_drop(this.c__product_filter_list, skip), limit)
    },

    c__flash_sale_files_filter_list() {
      return this.flash_sale_files
        .filter(i => i.shopId === this.shop._id)
        .filter(i => this.remove_unicode(JSON.stringify(i)).includes(this.remove_unicode(this.input_keyword)))
    }
  },

  methods: {
    async m__edit_entity_online() {
      this.loading.edit_online = true

      for (const item of this.product_selected_list) {
        for (const model of item.model_list) {
          if (!model.nomination_id) continue;

          const messages = []

          if (!+model.quantity) messages.push('Số lượng khuyến mãi phải lớn hơn 0')
          if (+model.quantity > +model.stock) messages.push('Số lượng khuyến mãi phải nhỏ hơn hoặc bằng tồn kho')
          if (!+model.discount_percent || +model.discount_percent < 3) messages.push('% khuyến mãi phải lớn hơn hoặc bằng 3')
          model.error_message = messages.join('\n')

          if (messages.length) {
            continue
          }

          const form = {
            session_id: this.campaign.session_id,
            entity_type: 2,
            products: [
              {
                campaign_price: (model.discount_price * 100000).toString(),
                campaign_price_type: 1,
                campaign_stock: model.quantity.toString(),
                discount: model.discount_percent.toString(),
                item_id: item.product.itemid.toString(),
                model_id: model.modelid.toString(),
                nomination_id: model.nomination_id.toString()
              }
            ]
          }

          const edit_response = await this.seller.edit_online_nominated_entity(form)
          console.log('edit_online_nominated_entity', edit_response.data)

          if (edit_response && edit_response.data && edit_response.data.failed_reason) {
            if (edit_response.data.failed_reason[0] !== 'Nothing Changed') {
              messages.push(edit_response.data.failed_reason[0])
            }
            model.error_message = messages.join('\n')
          }
        }
      }

      this.ntf_s(this.$t('base.update_success'))

      this.loading.edit_online = false
    },

    async m__submit_online_nominated_entity() {
      const {nomination_start_time} = this.campaign
      if (nomination_start_time > this.dayjs().unix()) {
        this.ntf_w('Chưa đến thời gian đăng ký. Thời gian đăng ký sẽ bắt đầu từ ' + this.dayjs(nomination_start_time * 1000).format('HH:mm DD/MM/YYYY'))
        return
      }

      this.loading.submit_online = true
      let has_error = false
      for (const item of this.preview_product_selected_list) {
        for (const model of item.model_list) {
          const messages = []

          if (!+model.quantity) messages.push('Số lượng khuyến mãi phải lớn hơn 0')
          if (+model.quantity > +model.stock) messages.push('Số lượng khuyến mãi phải nhỏ hơn hoặc bằng tồn kho')
          if (!+model.discount_percent || +model.discount_percent < 3) messages.push('% khuyến mãi phải lớn hơn hoặc bằng 3')
          model.error_message = messages.join('\n')

          if (messages.length) {
            has_error = true
            continue
          }

          const form = {
            session_id: this.campaign.session_id,
            preview_no: this.preview_no,
            update_product_preview_infos: [
              {
                nomination_ids: [model.nomination_id],
                campaign_stock: model.quantity.toString(),
                // campaign_price_type: 2,
                // discount: model.discount_percent.toString()
                campaign_price_type: 1,
                campaign_price: Math.floor(model.discount_price * 100000).toString()
              }
            ],
            types: [2]
          }

          const response = await this.seller.edit_preview_entity(form)
          console.log('edit_preview_entity', response)
          if (response && response.code) {
            messages.push(response.msg)
          }

          if (response && response.data && response.data.operate_preview_product_result_map[item.product.itemid]
            && response.data.operate_preview_product_result_map[+item.product.itemid].operate_preview_model_result_map
            && response.data.operate_preview_product_result_map[+item.product.itemid].operate_preview_model_result_map
            && response.data.operate_preview_product_result_map[+item.product.itemid].operate_preview_model_result_map[+model.modelid].operate_preview_error_map
          ) {
            const nested = response.data.operate_preview_product_result_map[+item.product.itemid].operate_preview_model_result_map[+model.modelid].operate_preview_error_map
            for (const key of Object.keys(nested)) {
              if (nested[key].error_msg) messages.push(nested[key].error_msg)
            }
          }

          model.error_message = messages.join('\n')
          if (messages.length) {
            // has_error = true
          }
        }
      }

      // if (!has_error) {
      if (true) {
        const response = await this.seller.submit_online_nominated_entity({
          session_id: this.campaign.session_id,
          entity_type: 2,
          confirm_risky: false
        })
        console.log('submit_online_nominated_entity', response)
        if (response && response.data) {
          if (response.data.failed_model_num) {
            this.ntf_w(`Không thể tạo thành công ${response.data.failed_model_num} phân loại`)
          } else {
            this.ntf_s('Gửi yêu cầu đăng ký thành công')
            this.tab = '0'
          }
        } else {
          this.ntf_w(this.$t('base.has_an_occurred'))
        }
      }

      this.loading.submit_online = false
    },

    async m__get_session_nomination_statistics() {
      const response = await this.seller.get_session_nomination_statistics(this.campaign.session_id)
      console.log('get_session_nomination_statistics', response.data)
      this.session_nomination_statistics = response.data
    },

    m__can_add_product() {
      return this.preview_product_selected_list.length + this.product_selected_list.length < this.campaign.nomination_seat
    },

    async m__update_flash_sale_filename() {
      if (!this.selected_file_update || !this.selected_file_update.filename) {
        this.ntf_w(this.$t('required.filename'))
        return
      }

      try {
        await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale/filename', {
          ...this.selected_file_update
        }, this.cf())
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__update_discount_flash_sale_file() {
      this.loading.update_discount = true

      this.selected_file_update.products = this.flash_sale_file_product_list.map(i => {
        return {
          productId: i.product.itemid,
          models: JSON.stringify(i.model_list)
        }
      })

      try {
        await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale', {
          ...this.selected_file_update
        }, this.cf())
        await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale/filename', {
          ...this.selected_file_update
        }, this.cf())

        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.show_flash_sale_file_products = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.update_discount = false
      }
    },

    async m__remove_flash_sale_file_product(item) {
      try {
        await this.$confirm(this.$t('base.delete_product_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
        this.flash_sale_file_product_list = this.flash_sale_file_product_list.filter(i => i.product.itemid !== item.product.itemid)
        await this.m__delete_item(item)
      } catch (e) {
      }
    },

    m__show_flash_sale_file_products(file) {
      if (!file.shopId) {
        this.ntf_w(this.$t('required.shop'))
        return
      }

      this.selected_file_update = file

      this.flash_sale_file_product_list = this.product_list.reduce((result, product) => {
        const product_found = file.products.find(i => i.productId === product.itemid)
        if (product_found) {
          const row = {
            product: product,
            model_list: product_found.models
              ? JSON.parse(product_found.models).map(model => {
                const model_found = this.clone(this.model_list[product.itemid]).find(i => i.modelid === model.modelid)
                if (model_found) {
                  model.name = model.name || ''
                  model.price = model_found.price
                  model.stock = model_found.stock
                }
                return model
              })
              : this.clone(this.model_list[product.itemid])
          }
          if (!row.product.display_name) row.product.display_name = product.name
          result.push(row)
        }
        return result
      }, [])
      this.show_dialog.show_flash_sale_file_products = true
    },

    async m__delete_flash_sale_file(item) {
      try {
        await this.$confirm(this.$t('flash_sale.delete_file_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/flash_sale', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            flashSaleFileId: item.id
          }
        })
        await this.m__get_flash_sale_files()
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
      }
    },

    async m__back_to_list() {
      this.$emit('m__back_to_list', true)

      // if (this.product_selected_list.length > 0 && this.save_and_apply_successfully) {
      //   this.$emit('m__back_to_list', true)
      // } else {
      //   try {
      //     await this.$confirm(this.$t('flash_sale.back_to_list_message'), this.$t('base.attention'), {
      //       type: 'warning',
      //       confirmButtonText: this.$t('base.confirm'),
      //       cancelButtonText: this.$t('base.cancel')
      //     })
      //   } catch (e) {
      //     this.$emit('m__back_to_list', true)
      //   }
      // }
    },

    async m__get_preview_product_list() {
      if (this.tab !== 'preview') {
        this.loading.use_file = false
        return
      }

      this.preview_product_selected_list = []

      const [campaign] = this.campaigns

      const form = {
        entity_type: [2],
        session_id: campaign.session_id
      }
      const response = await this.seller.get_preview_entity_list(form)
      if (!response.data) return

      this.preview_no = response.data.preview_no

      for (const item of response.data.entity_list_data.recruiting_entities) {
        const product = this.clone(this.product_list.find(i => +i.itemid === +item.product.item_id))
        if (product) {
          const batch_items = item.product.models
          this.preview_product_selected_list.push({
            product: {
              ...product,
              display_name: item.product.item_display_name,
              display_image: item.product.item_display_image.display_image,
              limit: !!+item.product.purchase_limit ? 1 : 0,
              limit_value: +item.product.purchase_limit
            },
            item_stock_price_infos: this.item_stock_price_infos.find(i => i.item_id === product.itemid),
            model_list: this.clone(this.model_list[product.itemid]).map(i => {
              // i.enable = true
              i.enable = false

              const batch = batch_items.find(ii => +ii.model_id === +i.modelid)
              if (batch) {
                product.limit = batch.purchase_limit > 0 ? 1 : 0
                product.limit_value = batch.purchase_limit

                i.nomination_id = batch.nomination_id
                i.stock = +batch.current_stock
                i.quantity = +batch.campaign_stock
                i.price = Math.floor(batch.original_price / 100000)
                i.discount_price = Math.floor(batch.campaign_price / 100000)
                i.discount_percent = 100 - Math.floor(i.discount_price * 100 / i.price)
                i.message = ''
                i.error_message = ''
                i.review_status = batch.nominate_status === 30 ? 1 : 3
                i.enable = false

              }
              return i
            }).sort((a, b) => (b.review_status || 0) - (a.review_status || 0))
          })
        }
      }
    },

    async m__get_product_list() {
      if (this.tab === 'preview') return

      this.product_selected_list = []

      const [campaign] = this.campaigns

      const form = {
        entity_tab: +this.tab,
        entity_type: [2],
        page_num: 1,
        page_size: 100,
        session_id: campaign.session_id
      }
      const response = await this.seller.get_nominated_entity_list(form)
      if (!response.data) return

      this.preview_no = response.data.preview_no

      for (const item of response.data.recruiting_entities) {
        const product = this.clone(this.product_list.find(i => +i.itemid === +item.product.item_id))
        if (product) {
          const batch_items = item.product.models
          this.product_selected_list.push({
            product: {
              ...product,
              display_name: item.product.item_display_name,
              display_image: item.product.item_display_image.display_image,
              limit: !!+item.product.purchase_limit ? 1 : 0,
              limit_value: +item.product.purchase_limit
            },
            item_stock_price_infos: this.item_stock_price_infos.find(i => i.item_id === product.itemid),
            model_list: this.clone(this.model_list[product.itemid]).map(i => {
              // i.enable = true
              i.enable = false

              const batch = batch_items.find(ii => +ii.model_id === +i.modelid)
              if (batch) {
                product.limit = batch.purchase_limit > 0 ? 1 : 0
                product.limit_value = batch.purchase_limit
                i.nomination_id = batch.nomination_id
                i.stock = +batch.current_stock
                i.quantity = +batch.campaign_stock
                i.price = Math.floor(batch.original_price / 100000)
                i.discount_price = Math.floor(batch.campaign_price / 100000)
                i.discount_percent = 100 - Math.floor(i.discount_price * 100 / i.price)
                i.message = ''
                i.error_message = ''
                i.review_status = batch.nominate_status === 30 ? 1 : 3
                i.enable = false
              }
              return i
            }).sort((a, b) => (b.review_status || 0) - (a.review_status || 0))
          })
        }
      }
    },

    async m__remove_product(data) {
      const {
        item,
        type
      } = data

      try {
        await this.$confirm(this.$t('base.delete_product_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
      } catch (e) {
        return
      }

      if (type === 'delete_preview_entity') {
        const response = await this.seller.delete_preview_entity({
          nomination_ids: item.model_list.filter(i => i.nomination_id).map(i => i.nomination_id.toString()),
          preview_no: this.preview_no,
          session_id: this.campaign.session_id,
        })
        console.log('delete_preview_entity', response)

        await this.m__get_preview_product_list()
        await this.m__get_session_nomination_statistics()
      }

      if (type === 'withdraw_entity') {
        for (const model of item.model_list.filter(i => i.nomination_id)) {
          const response = await this.seller.withdraw_entity({
            nomination_id: model.nomination_id,
            session_id: this.campaign.session_id,
          })
          console.log('withdraw_entity', response)
        }

        await this.m__get_product_list()
        await this.m__get_session_nomination_statistics()
      }
    },

    async m__get_flash_sale_files() {
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale/official', {
        ...this.cf(),
        params: {mipeeUserId: this.$store.state.userInfo.username}
      })
      const resp2 = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale', {
        ...this.cf(),
        params: {mipeeUserId: this.$store.state.userInfo.username}
      })
      const resp_auto = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale/auto', {
        ...this.cf(),
        params: {mipeeUserId: this.$store.state.userInfo.username}
      })
      for (const item of [...resp.data, ...resp2.data]) {
        item.auto = resp_auto.data.find(i => i.flashSaleFileId === item.id)
      }
      this.flash_sale_files = [...resp.data, ...resp2.data]

      this.$emit('m__get_flash_sale_files')
    },

    m__get_product() {
      this.$emit('m__get_product')
    },

    m__product_sort_change({
                             prop,
                             order
                           }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    m__select_all() {
      this.indeterminate = false
      if (this.is_selected_all) {
        this.c__product_filter_list.forEach(i => {
          i.selected = true
        })
      } else {
        this.product_list.forEach(i => {
          i.selected = false
        })
      }
    },

    m__indeterminate() {
      if (this.product_list.filter(i => i.selected === true).length === this.product_list.length) {
        this.is_selected_all = true
        this.indeterminate = false
      } else if (this.product_list.filter(i => i.selected === true).length === 0) {
        this.is_selected_all = false
        this.indeterminate = false
      } else {
        this.is_selected_all = false
        this.indeterminate = true
      }
    },

    m__show_flash_sale_files_dialog() {
      this.show_dialog.flash_sale_files = true
    },

    m__show_select_product_dialog() {
      if (!this.c__product_filter_list.find(i => i.checked.length)) {
        this.indeterminate = false
      }
      this.show_dialog.select_product = true
    },

    async m__confirm_select_product() {
      const product_filter = this.product_list.filter(i => i.selected)
      try {
        for (const product of product_filter) {
          if (!this.m__can_add_product()) break

          const new_product = {
            product: this.clone({
              ...product,
              display_name: product.name
            }),
            item_stock_price_infos: {...this.item_stock_price_infos.find(i => i.item_id === product.itemid)},
            model_list: this.clone(this.model_list[product.itemid].map(i => {
              i.review_status = null
              i.enable = false
              return i
            }))
          }
          for (const model of new_product.model_list) {
            model.discount_percent = 3
          }
          // this.preview_product_selected_list.push(new_product)

          const response = await this.seller.add_preview_entity({
            entity_list_data: {
              recruiting_entities: [
                {
                  entity_type: 2,
                  product: {
                    item_id: product.itemid.toString(),
                    models: new_product.model_list.map(m => ({
                      item_id: product.itemid.toString(),
                      model_id: m.modelid.toString()
                    })),
                  }
                }
              ]
            },
            fill_recommend_price: true,
            operate_start_time: this.dayjs().unix(),
            preview_no: this.preview_no,
            session_id: this.campaign.session_id
          })
          console.log('add_preview_entity', response)
          if (response.data && response.data.preview_no) {
            this.preview_no = response.data.preview_no
          }
        }
      } catch (e) {
        console.error(e)
      }

      await this.m__get_preview_product_list()
      await this.m__get_session_nomination_statistics()

      this.tab = 'preview'
      this.is_selected_all = false
      this.indeterminate = false
      this.product_list.forEach(i => i.selected = false)
      this.show_dialog.select_product = false
    },

    m__show_select_shop_dialog(data) {
      this.selected_shop_update = data.shopId
      this.selected_file_update = data
      this.show_dialog.select_shop = true
    },

    async m__use_flash_sale_file(file) {
      this.loading.use_file = true
      try {
        for (const product of file.products) {
          const product_found = this.product_list.find(i => i.itemid === product.productId)
          if (!product_found) continue

          if (!this.preview_product_selected_list.some(i => i.product.itemid === product_found.itemid)) {
            if (!this.m__can_add_product()) {
              continue
            }

            const new_product = {
              product: this.clone({
                ...product_found,
                display_name: product.display_name || product_found.name
              }),
              item_stock_price_infos: this.item_stock_price_infos.find(i => i.item_id === product_found.itemid),
              model_list: product.models
                ? JSON.parse(product.models).map(model => {
                  model.enable = false

                  const model_found = this.clone(this.model_list[product_found.itemid]).find(i => i.modelid === model.modelid)
                  if (model_found) {
                    model.price = model_found.price
                    model.stock = model_found.stock
                    model.quantity = +model.stock >= 3 ? model.quantity : model_found.stock
                    model.enable = model.stock <= 0
                  }
                  // model.enable = !model.review_status
                  model.nomination_id = null
                  model.review_status = null
                  return model
                })
                : this.clone(this.model_list[product_found.itemid])
            }

            const response = await this.seller.add_preview_entity({
              entity_list_data: {
                recruiting_entities: [
                  {
                    entity_type: 2,
                    product: {
                      item_id: product_found.itemid.toString(),
                      models: new_product.model_list.map(m => ({
                        item_id: product_found.itemid.toString(),
                        model_id: m.modelid.toString()
                      })),
                    }
                  }
                ]
              },
              fill_recommend_price: true,
              operate_start_time: this.dayjs().unix(),
              preview_no: this.preview_no,
              session_id: this.campaign.session_id
            })
            console.log('add_preview_entity fs file', response)
            if (response.data && response.data.preview_no) {
              this.preview_no = response.data.preview_no

              // todo: set discount + quantity
              const form = {
                entity_type: [2],
                session_id: this.campaign.session_id
              }
              const preview_response = await this.seller.get_preview_entity_list(form)
              for (const item of preview_response.data.entity_list_data.recruiting_entities) {
                if (+product_found.itemid === +item.product.item_id) {
                  for (const model of item.product.models) {
                    const model_found = JSON.parse(product.models).find(i => +i.modelid === +model.model_id)
                    const form = {
                      session_id: this.campaign.session_id,
                      preview_no: this.preview_no,
                      update_product_preview_infos: [
                        {
                          nomination_ids: [model.nomination_id],
                          campaign_stock: model_found.quantity.toString(),
                          campaign_price_type: 1,
                          campaign_price: Math.floor(model_found.discount_price * 100000).toString()
                        }
                      ],
                      types: [2]
                    }

                    const edit_preview_entity = await this.seller.edit_preview_entity(form)
                    console.log('edit_response', edit_preview_entity)
                  }
                }
              }
              // todo: end set discount + quantity
            }
          } else {
            // todo: set discount + quantity
            const form = {
              entity_type: [2],
              session_id: this.campaign.session_id
            }
            const preview_response = await this.seller.get_preview_entity_list(form)
            for (const item of preview_response.data.entity_list_data.recruiting_entities) {
              if (+product_found.itemid === +item.product.item_id) {
                for (const model of item.product.models) {
                  const model_found = JSON.parse(product.models).find(i => +i.modelid === +model.model_id)
                  const form = {
                    session_id: this.campaign.session_id,
                    preview_no: this.preview_no,
                    update_product_preview_infos: [
                      {
                        nomination_ids: [model.nomination_id],
                        campaign_stock: model_found.quantity.toString(),
                        campaign_price_type: 1,
                        campaign_price: Math.floor(model_found.discount_price * 100000).toString()
                      }
                    ],
                    types: [2]
                  }

                  const edit_preview_entity = await this.seller.edit_preview_entity(form)
                  console.log('edit_response', edit_preview_entity)
                }
              }
            }
            // todo: end set discount + quantity
          }
        }

        await this.m__get_preview_product_list()
      } catch (e) {
        console.error(e)
        this.ntf_w('Đã có lỗi trong quá trình sử dụng file')
      } finally {
        this.tab = 'preview'
        this.show_dialog.flash_sale_files = false
        this.loading.use_file = false
      }
    },

    m__get_shop_name(data) {
      if (this.shops && data.shopId) {
        const found = this.shops.find(i => i._id === data.shopId)
        return found ? found.username : ''
      }
      return ''
    },

    async m__save_and_apply() {
      this.loading.save_and_apply = true

      try {
        const [campaign] = this.campaigns

        const preview_list_response = await this.seller.get_preview_entity_list({
          entity_type: [2],
          session_id: campaign.session_id
        })
        const preview_no = preview_list_response.data.preview_no
        console.log(preview_no)

        for (const item of this.product_selected_list) {
          let display_image = item.product.display_image
          if (!display_image) {
            display_image = item.product.images.split(',')[0]
          }

          const nomination_id_null_list = item.model_list.filter(i => !i.nomination_id && !i.enable)

          await this.seller.add_preview_entity({
            entity_list_data: {
              recruiting_entities: [
                {
                  entity_type: 2,
                  product: {
                    item_id: item.product.itemid.toString(),
                    models: nomination_id_null_list.map(i => ({
                      item_id: item.product.itemid.toString(),
                      model_id: i.modelid.toString()
                    }))
                  }
                }
              ]
            },
            fill_recommend_price: true,
            preview_no: preview_no,
            session_id: campaign.session_id
          })

          const preview_list_response = await this.seller.get_preview_entity_list({
            entity_type: [2],
            session_id: campaign.session_id
          })
          console.log(preview_list_response.data.entity_list_data.recruiting_entities)

          for (const model of nomination_id_null_list) {
            const product_found = preview_list_response.data.entity_list_data.recruiting_entities.find(i => i.product.item_id === item.product.itemid.toString())
            console.log(product_found)
            if (product_found) {
              console.log(model.modelid.toString())
              const model_found = product_found.product.models.find(i => i.model_id === model.modelid.toString())
              console.log(model_found)
              model.nomination_id = model_found ? model_found.nomination_id : null
            }
          }

          for (const model of item.model_list) {
            if (!model.enable) {
              const form = {
                'products': [
                  {
                    'item_id': item.product.itemid.toString(),
                    'item_display_name': item.product.display_name,
                    'item_upload_image': display_image,
                    'purchase_limit': item.product.limit.toString(),
                    'campaign_stock': model.quantity.toString(),
                    'model_id': model.modelid.toString(),
                    'campaign_price': (model.discount_price * 100000).toString(),
                    'discount': model.discount_percent.toString(),
                    'nomination_id': model.nomination_id || ''
                  }
                ],
                'session_id': campaign.session_id,
                'entity_type': 2
              }

              const response = await this.seller.edit_online_nominated_entity(form)
              console.log(response.data)
              if (response.data.success) {
                // this.ntf_s('Gửi yêu cầu đăng ký thành công')
              } else {
                model.error_message = 'Đã có lỗi xảy ra khi đăng ký sản phẩm. Mã lỗi: ' + response.data.failed_reason.join(', ')
              }
            }
          }
        }
        this.ntf_s('Đã gửi yêu cầu đăng ký')
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.save_and_apply = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/flash_sale_shopee/update.vue